export default "__VITE_ASSET__WPGYjwIlzWVNM1bYhOc83w__ 640w, __VITE_ASSET__FKNdLzKnlftW3t_gzo81yw__ 960w, __VITE_ASSET__8HSUfh7cJHNFxCkInNzNXw__ 1600w";